import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
// material
import { Box, Grid, Container, Typography } from "@mui/material";
// components
import Page from "../components/Page";
import { VisaExtensionAdminTable } from "../components/_dashboard/app";
import { getVisaExtensionPostdocAdmin } from "../core/service/visaExtensionPostdoc.service";
// ----------------------------------------------------------------------
const ROLE_ADMIN = "admin";
const ROLE_MENTOR = "mentor";
const ROLE_PHD_3Y = "phd_3y";
const ROLE_PHD_5Y = "phd_5y";
const ROLE_POSTDOC = "post_doc";

export default function VisaExtension() {
  const navigate = useNavigate();
  const { role, user: currentUser } = useSelector((state) => state.authReducer);
  const { id } = currentUser;
  const [listVisaExtension, setListVisaExtension] = useState([{}]);
  const { entities } = listVisaExtension;

  const visaExtensionAdmin = async () => {
    const data = await getVisaExtensionPostdocAdmin();
    setListVisaExtension(data);
  };

  useEffect(() => {
    if (currentUser.role != ROLE_ADMIN) {
      navigate("/404", { replace: true });
    }
    visaExtensionAdmin();
  }, []);

  return (
    <Page title="Visa Extension">
      <Container maxWidth="xl">
        <Grid container spacing={3}>
          <Grid item xs={12} md={6} lg={12}>
            <VisaExtensionAdminTable listVisa={entities || []} />
          </Grid>
        </Grid>
      </Container>
    </Page>
  );
}
